// Dieses Skript ist für das Shopify-Frontend gedacht.
// Es überwacht den Warenkorb und zeigt eine Nachricht an, wenn ein Geschenk zusteht.
// Gleichzeitig wird eine Bestellnotiz erstellt, die im Backend sichtbar ist.

// Cart gift script loaded

// Debounce-Funktion, um zu viele Aktionen bei schnellen Warenkorb-Änderungen zu vermeiden.
function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
}

// Konfigurieren Sie die folgenden Werte:
const thresholdAmount = document.getElementById('gift-message').dataset.giftThreshold; // Der Warenkorbbetrag, bei dem der Bonus aktiviert wird
const giftNoteText = '🎁 GESCHENK HINZUFÜGEN: Kunde hat den Schwellenwert erreicht - bitte Geschenk beilegen!';
const messageElementId = 'gift-message';
const noteInputElementId = 'gift-note-attribute';

// Geschenk-Produkt ID aus Metafield (wird beim Laden gesetzt)
let giftProductId = null;

// Fallback: Versuche die Produkt-ID aus dem globalen Window-Objekt zu laden
function getGiftProductIdFromGlobal() {
  if (window.giftProductId) {
    // Wenn es ein Produkt-Objekt ist, nehmen wir die erste Variant-ID
    if (window.giftProductId.variants && window.giftProductId.variants.length > 0) {
      return window.giftProductId.variants[0].id;
    }
    // Falls es bereits eine ID ist, verwenden wir sie direkt
    if (typeof window.giftProductId === 'number' || typeof window.giftProductId === 'string') {
      return window.giftProductId;
    }
  }
  return null;
}

let currentCartTotal = 0;
let giftNoteAdded = false; // Track if gift note was already added
let giftProductAdded = false; // Track if gift product was already added

// Hilfsfunktion: Sichtbarkeit sicherstellen (Element soll immer gerendert bleiben)
function ensureVisible(element) {
  element.hidden = false;
  if (element.classList) {
    element.classList.remove('hidden', 'visually-hidden');
  }
  if (element.style && element.style.display === 'none') {
    element.style.display = '';
  }
}

// Funktion zum Hinzufügen der Geschenk-Notiz zum Warenkorb
async function addGiftNoteToCart() {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        note: giftNoteText,
      }),
    });

    if (!response.ok) {
      throw new Error('Fehler beim Hinzufügen der Geschenk-Notiz');
    }

    const cart = await response.json();
    console.log('🎁 API: Geschenk-Notiz hinzugefügt');
    giftNoteAdded = true;
  } catch (error) {
    console.error('Fehler beim Hinzufügen der Geschenk-Notiz:', error);
  }
}

// Funktion zum Entfernen der Geschenk-Notiz vom Warenkorb
async function removeGiftNoteFromCart() {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        note: '',
      }),
    });

    if (!response.ok) {
      throw new Error('Fehler beim Entfernen der Geschenk-Notiz');
    }

    console.log('🎁 API: Geschenk-Notiz entfernt');
    giftNoteAdded = false;
  } catch (error) {
    console.error('Fehler beim Entfernen der Geschenk-Notiz:', error);
  }
}

// Funktion zum Hinzufügen des Geschenk-Produkts zum Warenkorb
async function addGiftProductToCart() {
  if (!giftProductId) {
    console.warn('Geschenk-Produkt ID nicht verfügbar');
    return;
  }

  // Prüfen, ob Geschenk bereits im Warenkorb ist (verwende aktuellen Status)
  if (giftProductAdded) {
    return;
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: giftProductId,
        quantity: 1,
        properties: {
          _gift: 'true',
          _gift_source: 'automatic_threshold',
        },
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error Response:', errorText);
      throw new Error(`Fehler beim Hinzufügen des Geschenk-Produkts: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    console.log('🎁 API: Geschenk-Produkt hinzugefügt');
    giftProductAdded = true;

    // Cart Drawer neu rendern
    await refreshCartDrawer();
  } catch (error) {
    console.error('Fehler beim Hinzufügen des Geschenk-Produkts:', error);
  }
}

// Funktion zum Entfernen des Geschenk-Produkts vom Warenkorb
async function removeGiftProductFromCart() {
  if (!giftProductId) {
    console.warn('Geschenk-Produkt ID nicht verfügbar');
    return;
  }

  try {
    // Aktuellen Warenkorb abrufen
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // Alle Geschenk-Produkte im Warenkorb finden
    const giftItems = cart.items.filter((item) => {
      const isGiftProduct = item.product_id === window.giftProductId?.id;
      const hasGiftProperty = item.properties && item.properties._gift === 'true';
      return isGiftProduct && hasGiftProperty;
    });

    if (giftItems.length === 0) {
      giftProductAdded = false;
      return;
    }

    // Entferne jedes Geschenk-Item einzeln über Key (für Items mit Properties)
    for (const giftItem of giftItems) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: giftItem.key, // Verwende key statt id für Items mit Properties
          quantity: 0,
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`Fehler beim Entfernen von Item ${giftItem.key}:`, errorText);
        throw new Error(`Fehler beim Entfernen von Item ${giftItem.key}: ${response.status} - ${errorText}`);
      }

      const result = await response.json();
    }

    console.log('🎁 API: Geschenk-Produkt entfernt');
    giftProductAdded = false;

    // Cart Drawer neu rendern
    await refreshCartDrawer();
  } catch (error) {
    console.error('Fehler beim Entfernen des Geschenk-Produkts:', error);
  }
}

// Funktion zum Überprüfen des Warenkorbs und Aktualisieren der Benutzeroberfläche.
async function updateCartUI() {
  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Fehler beim Abrufen der Warenkorbdaten.');
    }

    console.log('🎁 API: Warenkorbdaten abgerufen für UpdateCartUI');

    const cart = await response.json();
    const newCartTotal = cart.total_price / 100; // Betrag in Euro umrechnen

    // Die Funktion nur ausführen, wenn sich der Warenkorbwert geändert hat.
    if (newCartTotal === currentCartTotal) {
      return;
    }

    currentCartTotal = newCartTotal;

    // Geschenk-Status aus Cart-Daten ermitteln (kein separater API-Call)
    const isGiftInCart = cart.items.find((item) => {
      const isGiftProduct = item.product_id === window.giftProductId?.id;
      const hasGiftProperty = item.properties && item.properties._gift === 'true';
      return isGiftProduct && hasGiftProperty;
    });
    giftProductAdded = !!isGiftInCart;

    const messageElement = document.getElementById(messageElementId);
    const noteInputElement = document.getElementById(noteInputElementId);

    // Nachrichtenelement ist zwingend erforderlich, Notizfeld optional
    if (!messageElement) {
      return;
    }

    // Überprüfen, ob der Warenkorbwert den Schwellenwert erreicht.
    // Element immer sichtbar halten
    ensureVisible(messageElement);

    // Klassenzustand je nach Schwellenwert setzen
    const reachedClass = 'gift-threshold-reached';
    const notReachedClass = 'gift-threshold-not-reached';

    if (newCartTotal >= thresholdAmount) {
      messageElement.classList.remove(notReachedClass);
      messageElement.classList.add(reachedClass);
      if (noteInputElement) {
        noteInputElement.value = giftNoteText;
      }

      // Geschenk-Notiz hinzufügen, wenn noch nicht hinzugefügt
      if (!giftNoteAdded) {
        await addGiftNoteToCart();
      }

      // Geschenk-Produkt hinzufügen, wenn noch nicht hinzugefügt
      if (!giftProductAdded) {
        await addGiftProductToCart();
      }
    } else {
      messageElement.classList.remove(reachedClass);
      messageElement.classList.add(notReachedClass);
      if (noteInputElement) {
        noteInputElement.value = '';
      }

      // Geschenk-Notiz entfernen, wenn Schwellenwert nicht mehr erreicht
      if (giftNoteAdded) {
        await removeGiftNoteFromCart();
      }

      // Geschenk-Produkt entfernen, wenn Schwellenwert nicht mehr erreicht
      if (giftProductAdded) {
        await removeGiftProductFromCart();
      }
    }

    // Entry-Animation auslösen (nur wenn Element noch existiert)
    if (messageElement) {
      // Kleine Verzögerung, damit das Rendering abgeschlossen ist
      requestAnimationFrame(() => {
        if (messageElement) {
          // Animation-Reset für erneute Ausführung
          messageElement.classList.remove('cart-gift-message--animate');

          // Force reflow
          messageElement.offsetHeight;

          // Animation starten
          messageElement.classList.add('cart-gift-message--animate');

          // Klasse nach Animation entfernen
          setTimeout(() => {
            if (messageElement) {
              messageElement.classList.remove('cart-gift-message--animate');
            }
          }, 500); // Animation-Dauer
        }
      });
    }
  } catch (error) {
    console.error('Ein Fehler ist bei der Warenkorbprüfung aufgetreten:', error);
  }
}

// Debounce die Funktion, um sie nicht bei jeder kleinen Änderung auszuführen.
const debouncedUpdate = debounce(updateCartUI, 500);

// Funktion zum Neuladen des Cart Drawers
async function refreshCartDrawer() {
  try {
    // Methode 2: Direkte Cart Drawer Aktualisierung
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
      try {
        cartDrawerItems.onCartUpdate();
      } catch (error) {
        console.log('Direct cart update failed:', error);
      }
    }
  } catch (error) {
    console.error('Fehler beim Aktualisieren des Cart Drawers:', error);
  }
}

// Event-basierte Warenkorb-Updates (kein Polling!)
function setupCartUpdateListener() {
  try {
    // Shopify's Pub/Sub-System (primär)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        setTimeout(() => debouncedUpdate(), 100);
      });
    }
  } catch (error) {
    console.warn('Pub/Sub nicht verfügbar, verwende direkte Event-Listener');
  }
}

// Funktion zum Laden der Geschenk-Produkt ID
async function loadGiftProductId() {
  // Methode 1: Aus data-gift-product-variant-id Attribut laden (neue bevorzugte Methode)
  const giftMessageElement = document.getElementById('gift-message');
  if (giftMessageElement && giftMessageElement.dataset.giftProductVariantId) {
    giftProductId = giftMessageElement.dataset.giftProductVariantId;
    return;
  }

  // Methode 2: Fallback - aus globalem Window-Objekt laden
  giftProductId = getGiftProductIdFromGlobal();
  if (giftProductId) {
    return;
  }

  // Methode 3: Fallback - Metafield über API abrufen
  try {
    const response = await fetch('/meta.json');
    console.log('🎁 API: Metafield abgerufen');
    if (!response.ok) {
      console.warn('Metafield API nicht verfügbar');
      return;
    }

    const meta = await response.json();
    if (meta.shop && meta.shop.metafields && meta.shop.metafields.custom && meta.shop.metafields.custom.gift_product) {
      giftProductId = meta.shop.metafields.custom.gift_product.value;
    }
  } catch (error) {
    console.warn('Fehler beim Laden der Geschenk-Produkt ID:', error);
  }
}

// Funktion zum Synchronisieren des Geschenk-Status beim Laden
async function syncGiftStatus() {
  if (!giftProductId) return;

  try {
    // Ein einziger API-Call für alles
    const response = await fetch('/cart.js');
    console.log('🎁 API: Warenkorbdaten abgerufen für Initial-Sync');
    const cart = await response.json();

    // Geschenk-Status prüfen
    const isInCart = cart.items.find((item) => {
      const isGiftProduct = item.product_id === window.giftProductId?.id;
      const hasGiftProperty = item.properties && item.properties._gift === 'true';
      return isGiftProduct && hasGiftProperty;
    });
    giftProductAdded = !!isInCart;

    // Schwellenwert prüfen
    const cartTotal = cart.total_price / 100;
    const isThresholdReached = cartTotal >= thresholdAmount;

    if (isThresholdReached && !giftProductAdded) {
      // Schwellenwert erreicht, aber kein Geschenk im Warenkorb -> hinzufügen
      await addGiftProductToCart();
    } else if (!isThresholdReached && giftProductAdded) {
      // Schwellenwert nicht erreicht, aber Geschenk im Warenkorb -> entfernen
      await removeGiftProductFromCart();
    }
  } catch (error) {
    console.error('Fehler beim Synchronisieren des Geschenk-Status:', error);
  }
}

// Startet die erste Überprüfung beim Laden der Seite.
window.addEventListener('load', async () => {
  await loadGiftProductId();
  await syncGiftStatus();
  // debouncedUpdate();
  setupCartUpdateListener();

  // Event-basierte Updates sind bereits aktiv
});
